import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './Tooltip.css';

const Tooltip = props => {
  const { children, messageId, rootClassName, className, direction = 'top' } = props;
  const [active, setActive] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const showTooltip = () => setActive(true);
  const hideTooltip = () => setActive(false);

  useEffect(() => {
    if (active && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      let newPosition = {};

      switch (direction) {
        case 'top':
          newPosition = {
            top: rect.top + window.scrollY - 90,
            left: rect.left + window.scrollX + rect.width / 2,
          };
          break;
        case 'right':
          newPosition = {
            top: rect.top + window.scrollY + rect.height / 2,
            left: rect.left + window.scrollX + rect.width + 10,
          };
          break;
        case 'bottom':
          newPosition = {
            top: rect.top + window.scrollY + rect.height + 10,
            left: rect.left + window.scrollX + rect.width / 2,
          };
          break;
        case 'left':
          newPosition = {
            top: rect.top + window.scrollY + rect.height / 2,
            left: rect.left + window.scrollX - 10,
          };
          break;
        default:
          newPosition = {
            top: rect.top + window.scrollY - 90,
            left: rect.left + window.scrollX + rect.width / 2,
          };
      }

      setPosition(newPosition);
    }
  }, [active, direction]);

  const classes = classNames(rootClassName || css.root, className);

  const getTransform = () => {
    switch (direction) {
      case 'top':
        return 'translate(-50%, 0)';
      case 'right':
        return 'translate(0, -50%)';
      case 'bottom':
        return 'translate(-50%, 0)';
      case 'left':
        return 'translate(-100%, -50%)';
      default:
        return 'translate(-50%, 0)';
    }
  };

  const tooltipContent = active && (
    <div
      className={css.container}
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: getTransform(),
      }}
    >
      <div
        className={classNames(
          css.tip,
          css[`tip${direction.charAt(0).toUpperCase() + direction.slice(1)}`]
        )}
      >
        <FormattedMessage id={messageId} />
      </div>
    </div>
  );

  return (
    <div className={classes}>
      <div ref={triggerRef} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
        {children}
      </div>
      {typeof document !== 'undefined' && createPortal(tooltipContent, document.body)}
    </div>
  );
};

export default Tooltip;
